import { render } from "./itemListTable.vue?vue&type=template&id=15db2e13&scoped=true"
import script from "./itemListTable.vue?vue&type=script&lang=js"
export * from "./itemListTable.vue?vue&type=script&lang=js"

import "./itemListTable.vue?vue&type=style&index=0&id=15db2e13&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15db2e13"]])

export default __exports__